const ADMIN_CLIENT = 'fulcrum/container/Admin/Client/Client'
const MOUNT = 'fulcrum/container/Admin/Client/Client/MOUNT'
const UNMOUNT = 'fulcrum/container/Admin/Client/Client/UNMOUNT'
const UPDATE_ACTIVE_DIALOG = 'fulcrum/container/Admin/Client/Client/UPDATE_ACTIVE_DIALOG'

const DIALOG_TYPE = Object.freeze({
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
})

export {
  DIALOG_TYPE,
  ADMIN_CLIENT,
  MOUNT,
  UNMOUNT,
  UPDATE_ACTIVE_DIALOG,
}
